import React from 'react';

export default class EmployeeImage extends React.Component {
    static propTypes = {
        guid: React.PropTypes.string.isRequired
    };
    render() {
        return (
            <img
                className="avatar" 
                src={`${__FG_COMPANY_IMAGES_HOST__}index.php/ext/employee_avatar/${this.props.guid}/60`} />
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/clients/EmployeeImage.js